import cortadoIcon from '@cortado/shared-assets/logos/cortado-icon.svg'

export function CortadoIcon({ className }: { className?: string }) {
  return <img src={cortadoIcon} alt="Cortado" className={className} />
}
